import React from "react";
import { Form } from 'react-bootstrap';

interface SwitchProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className: string;
  label?: string;
}

export const Switch: React.FC<SwitchProps> = ({ id, checked, onChange, className, label = 'Active' }) => {
  return (
    <Form.Check className="form-switch switch-lg ">
      <Form.Check.Input
        type="checkbox"
        className={`input-primary  f-16 ${className}`}
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <Form.Check.Label htmlFor={id}>{label}</Form.Check.Label>
    </Form.Check>
  );
};

